import {
  activateCreditCard,
  authorizeWallet,
  debugPaymentMethods,
  getActiveMethod,
  getAvailableMethods,
  hasActiveMethod,
  hasRestrictions,
  init as initPaymentMethods,
  isActiveMethodAuthorized,
  isInitializationComplete,
  membershipPaymentMethods,
  prepareWallets,
  selectWallet,
  submitCreditCard,
  updateAvailableMethods,
} from './paymentMethods/paymentMethods';
import { renderPayPalButton } from './paymentMethods/paypalOneTouch/paypalOneTouch';
import logger, { initializeLogger } from './lib/log';

import {
  completeNativeAuthorization as androidPayCompleteNativeAuthorization,
} from './paymentMethods/androidPay/androidPay';

import {
  completeNativeAuthorization as applePayCompleteNativeAuthorization,
} from './paymentMethods/applePay/applePay';

const log = logger('Payments.js');

/**
 * setupNativePaymentCallbacks
 *
 * Exposes callback functions used by the native apps to complete the verification process for a wallet.
 *
 * NOTE: The name of the functions exposed on the window are called EXTERNALLY
 * so they cannot easily be renamed as we'd also need to make updates to the apps as well.
 */
const setupNativePaymentCallbacks = () => {
  // Google Pay
  window.FANDANGO.paymentMethods.types = {
    androidpay: {
      onDoneNativeAppAuth: androidPayCompleteNativeAuthorization,
    },
  };

  // Apple Pay
  window.applePayReceiveBraintreeNonce = applePayCompleteNativeAuthorization;

  // Venmo - n/a
};

const init = (options) => {
  initializeLogger();
  // Expose specific functions, so they can be called by gulp/fdRequire code that currently cannot simply *import* these
  // Ideally one day the whole project will use compatible processes, at which point this file will not be needed.
  window.FANDANGO.paymentMethods = {
    activateCreditCard,
    authorizeWallet,
    debug: debugPaymentMethods,
    getActiveMethod,
    getAvailableMethods,
    hasActiveMethod,
    isActiveMethodAuthorized,
    isInitializationComplete,
    hasRestrictions,
    membershipPaymentMethods,
    prepareWallets,
    renderPayPalButton,
    selectWallet,
    submitCreditCard,
    updateAvailableMethods,
  };
  if (options.isAppWebView) {
    setupNativePaymentCallbacks();
  }

  log('configuration options', options);
  initPaymentMethods(options);
};

window.FANDANGO = window.FANDANGO || {};
window.FANDANGO.payments = init;
